import { X } from '@griply/assets';
import React, { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Icon } from 'shared/components/ui/icon';

import * as Styled from './popup-menu.style';
import { Colors } from './types';

export type PopupMenuInputProps = React.ComponentProps<'input'> & {
  startIcon?: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
  iconColor?: Colors;
  textColor?: Colors;
  inputHidden?: boolean;
  compact?: boolean;
  onClear?: () => void;
};

export const PopupMenuInput = forwardRef<HTMLInputElement, PopupMenuInputProps>(
  (
    {
      startIcon,
      children,
      iconColor,
      textColor,
      inputHidden,
      compact,
      onClear,
      id,
      ...rest
    },
    ref,
  ) => {
    const { t } = useTranslation();

    return (
      <Styled.InputLabel
        htmlFor={id}
        $color={textColor}
        $noHover={!inputHidden}
        $compact={!!compact}
      >
        {!!startIcon && (
          <Styled.AffixContainer $color={iconColor}>
            <Icon icon={startIcon} />
          </Styled.AffixContainer>
        )}
        {children}
        <Styled.Input
          ref={ref}
          $hasStartIcon={!!startIcon}
          $hidden={!!inputHidden}
          id={id}
          {...rest}
        />
        {!!onClear && (
          <Styled.InputClearButton
            onClick={onClear}
            aria-label={t('general.labels.clear-field')}
            type="button"
            tabIndex={-1}
          >
            <Icon icon={X} />
          </Styled.InputClearButton>
        )}
      </Styled.InputLabel>
    );
  },
);
